/** SA7 — menú BackOffice: path + perm. Sidebar y rutas leen de aquí. */
import { isPlatformOwner } from '@/lib/platformOwner';

export const BACKOFFICE_NAV = [
  { path: '/backoffice', label: 'Cuentas', perm: 'companies' },
  { path: '/backoffice/uso-ia', label: 'Usabilidad por Tenant', perm: 'analytics' },
  { path: '/backoffice/planes', label: 'Planes', perm: 'plans' },
  { path: '/backoffice/propiedades', label: 'Propiedades', perm: 'properties' },
  { path: '/backoffice/reportes', label: 'Reportes', perm: 'reports' },
  { path: '/backoffice/superadmins', label: 'Super Admins', perm: 'superadmins' },
  { path: '/backoffice/user-tenants', label: 'User tenants', perm: 'superadmins' },
  { path: '/backoffice/integraciones', label: 'Integraciones', perm: 'integrations' },
  { path: '/backoffice/email-config', label: 'Email SES', perm: 'integrations' },
  { path: '/backoffice/tracking-publicitario', label: 'Tracking Publicitario', perm: 'integrations' },
  { path: '/backoffice/proyectos', label: 'Proyectos', perm: 'projects' },
  { path: '/backoffice/academy', label: 'Academy', perm: 'academy' },
  { path: '/backoffice/bitacora', label: 'Bitacora', perm: 'audit' },
  { path: '/backoffice/suspensiones', label: 'Suspensiones', perm: 'audit' },
];

export function tieneSaPerm(user, perm) {
  if (!user) return false;
  if (isPlatformOwner(user)) return true;
  return (user.sa_permissions || {})[perm] !== false;
}

export function permDeRuta(pathname) {
  const path = String(pathname || '');
  const exacto = BACKOFFICE_NAV.find((i) => i.path === path);
  if (exacto) return exacto.perm;
  const hits = BACKOFFICE_NAV
    .filter((i) => i.path !== '/backoffice' && path.startsWith(i.path))
    .sort((a, b) => b.path.length - a.path.length);
  return (hits[0] || BACKOFFICE_NAV[0]).perm;
}

export function primeraRutaPermitida(user) {
  const item = BACKOFFICE_NAV.find((i) => tieneSaPerm(user, i.perm));
  return item ? item.path : '/dashboard';
}
